import { render, staticRenderFns } from "./columnList.vue?vue&type=template&id=08bcbb20&scoped=true&"
import script from "./columnList.vue?vue&type=script&lang=js&"
export * from "./columnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bcbb20",
  null
  
)

export default component.exports